import React from 'react';
import {
  Edit,
  SimpleForm,
  required,
  TextInput,
  SaveButton,
  Toolbar,
  DeleteButton,
} from 'react-admin';

const CategoryEditToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton alwaysEnable />
    <DeleteButton />
  </Toolbar>
);

export const CategoryEdit = () => {
  return (
    <Edit>
      <SimpleForm toolbar={<CategoryEditToolbar />}>
        <TextInput source="name" validate={required()} fullWidth />
        <TextInput source="code" validate={required()} fullWidth />
      </SimpleForm>
    </Edit>
  );
};
